import * as types from '../mutation-types'
import PlatformsApi from "../../api/platforms";
import axios from "axios";

// state
export const state = {
    all: []
};

// getters
export const getters = {
    all: state => state.all
};

// mutations
export const mutations = {
    [types.PLATFORMS_ALL_SET] (state, all) {
        state.all = all;
    }
};

// actions
export const actions = {
    async fetch(context) {
        context.commit(types.PLATFORMS_ALL_SET, await PlatformsApi.getAll());
    },
};
